module.exports = __webpack_public_path__ + "static/media/alerts-activated.01a75621.svg";